module.exports = __webpack_public_path__ + "img/angola.f6c422b6.png";